import { createAction, props } from "@ngrx/store"
import { ChannelProduct, ChannelProductTransaction, MTBTransactions, OutstandingBalance, PaymentChannel, ProductEarning } from "./dashboard.interfaces"

export const fetchOutstandingBalance = createAction(
    '[DashBoard Module] fetch outstanding balance'
)

export const fetchOutstandingBalanceFailed = createAction(
    '[DashBoard Module] STATUS: fetch outstanding balance failed'
)

export const fetchOutstandingBalanceSuccess = createAction(
    '[DashBoard Module] STATUS: fetch outstanding balance success',
    props<{outstandingBalance: OutstandingBalance}>()
)


export const fetchTransactionHistory = createAction(
    '[DashBoard Module] fetch transaction history ',
     props<{
    txnId: string;
    status: string;
    startDate?: string; 
    endDate?: string;
  }>()
)

export const fetchTransactionHistoryFailed = createAction(
    '[DashBoard Module] STATUS: fetch transaction history failed'
)

export const fetchTransactionHistorySuccess = createAction(
    '[DashBoard Module] STATUS: fetch transaction history  success',
    props<{transactionHistory}>()
)


export const fetchPendingTransactions = createAction(
    '[DashBoard Module] fetch pending transactions',
    props<{txnId: string; page?: number; limit?: number}>()
)



export const fetchPendingTransactionsFailed = createAction(
    '[DashBoard Module] STATUS: fetch pending transactions failed'
)

export const fetchPendingTransactionsSuccess = createAction(
    '[DashBoard Module] STATUS: fetch pending transactions success',
    props<{ pendingTransactions: any }>() // Fix TypeScript typing
)




export const fetchPaymentChannels = createAction(
    '[DashBoard Module] fetch payment channels'
)

export const fetchPaymentChannelsFailed = createAction(
    '[DashBoard Module] STATUS: fetch payment channels failed'
)

export const fetchPaymentChannelsSuccess = createAction(
    '[DashBoard Module] STATUS: fetch payment channels success',
    props<{paymentChannels: PaymentChannel[]}>()
)

export const fetchChannelProducts = createAction(
    '[DashBoard Module] fetch channel products',
    props<{channelId: string}>()
)

export const fetchChannelProductsFailed = createAction(
    '[DashBoard Module] STATUS: fetch channel products failed'
)

export const fetchChannelProductsSuccess = createAction(
    '[DashBoard Module] STATUS: fetch channel products success',
    props<{channelProducts: ChannelProduct[]}>()
)



export const fetchProductEarning = createAction(
    '[DashBoard Module] fetch product earning',
    props<{channelId: string, productId: string}>()
)

export const fetchProductEarningFailed = createAction(
    '[DashBoard Module] STATUS: fetch product earning failed'
)
export const fetchProductEarningSuccess = createAction(
    '[DashBoard Module] STATUS: fetch product earning success',
    props<{productEarning: ProductEarning[]}>()
)

export const fetchTransactionsPerDay = createAction(
    '[DashBoard Module] fetch transactions per day',
    props<{productId: string, date: string}>()
)

export const fetchTransactionsPerDayFailed = createAction(
    '[DashBoard Module] STATUS: fetch transactions per day failed'
)
export const fetchTransactionsPerDaySuccess = createAction(
    '[DashBoard Module] STATUS: fetch transactions per day success',
    props<{transactions: ChannelProductTransaction[]}>()
)

export const fetchMTBtransactions = createAction(
    '[DashBoard Module] fetch move to bank transactions by status',
    props<{status: string}>()
)

export const fetchMTBtransactionsFailed = createAction(
    '[DashBoard Module] STATUS: fetch move to bank transactions by status failed'
)
export const fetchMTBtransactionsSuccess = createAction(
    '[DashBoard Module] STATUS: fetch move to bank transactions by status success',
    props<{transactions: MTBTransactions[]}>()
)
